import styled from 'styled-components'
import { Flex } from '@pancakeswap/uikit'

const FlexRow = styled(Flex).attrs({ alignItems: 'center' })`
  flex: 1;
`

export default FlexRow
